import { Button, Dialog, FormControlLabel, IconButton, styled, Switch, SwitchProps, TextField,
    MenuItem } from "@mui/material"
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useEffect, useState } from "react";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import DeleteIcon from '@mui/icons-material/Delete';
import { ApiRequest } from "GlobalFunctions";
import ISwitch from "elements/ISwitch";

const defaultValues = {
    logic_id: "",
    logic_name: "",
    conditions: {
        variables: [
            {
                variable: "",
                bag: "show",
                cart: "show",
                checkout: "show",
                invoice: "show",
            }
        ],
    },
}

export default function HideVariables(props: any) {

    const {
        setLogicType,
        logicValues,
        setLogicvalues
    } = props;

    useEffect(() => {
        console.log("logicValues----", logicValues);
        if (!logicValues.logic_id) {
            console.log("newww");
            setLogicvalues(defaultValues);
        }
    }, []);

    useEffect(() => {
        if (!logicValues.conditions || !Array.isArray(logicValues.conditions.variables)) {
            setLogicvalues({
                ...logicValues,
                conditions: {
                    variables: [
                        {
                            variable: "",
                            bag: "show",
                            cart: "show",
                            checkout: "show",
                            invoice: "show",
                        }
                    ],
                },
            });
        }
    }, [logicValues]);

    if (!logicValues.conditions || !Array.isArray(logicValues.conditions.variables)) {
        return null;
    }
    
    return (
        <>
            <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                label="Name"
                size="small"
                value={logicValues.logic_name}
                onChange={(e) => setLogicvalues({...logicValues, logic_name: e.target.value})}
            />

            <div className="input_group">
                <div className="dialog_section_title">
                    <div>
                        <h2 className="h2_section_title">Product Options</h2>
                        <span className="subitle">Add more product options by clicking ‘Add Product Option'</span>
                    </div>
                </div>
                
                {logicValues.conditions.variables.map((variable: any, variableIndex: number) => (
                    <div key={variableIndex} className="input_group">
                        <div className="input_row">

                            <TextField
                                fullWidth
                                label="Product Option"
                                InputLabelProps={{ shrink: true }}
                                size="small"
                                value={variable.variable}
                                onChange={(e) => {
                                    let conditions = {...logicValues.conditions};
                                    conditions.variables[variableIndex].variable = e.target.value;
                                    setLogicvalues({...logicValues, conditions: conditions});
                                }}
                            />
                            
                            <TextField
                                fullWidth
                                id="bag"
                                label="Bag"
                                value={variable.bag}
                                name="bag"
                                size="small"
                                select
                                onChange={(e) => {
                                    let conditions = {...logicValues.conditions};
                                    conditions.variables[variableIndex].bag = e.target.value;
                                    setLogicvalues({...logicValues, conditions: conditions});
                                }}
                            >
                                <MenuItem value={"hide"}>Hide</MenuItem>
                                <MenuItem value={"show"}>Show</MenuItem>
                            </TextField>

                            <TextField
                                fullWidth
                                id="cart"
                                label="Cart"
                                value={variable.cart}
                                name="cart"
                                size="small"
                                select
                                onChange={(e) => {
                                    let conditions = {...logicValues.conditions};
                                    conditions.variables[variableIndex].cart = e.target.value;
                                    setLogicvalues({...logicValues, conditions: conditions});
                                }}
                            >
                                <MenuItem value={"hide"}>Hide</MenuItem>
                                <MenuItem value={"show"}>Show</MenuItem>
                            </TextField>

                            <TextField
                                fullWidth
                                id="checkout"
                                label="Checkout"
                                value={variable.checkout}
                                name="checkout"
                                size="small"
                                select
                                onChange={(e) => {
                                    let conditions = {...logicValues.conditions};
                                    conditions.variables[variableIndex].checkout = e.target.value;
                                    setLogicvalues({...logicValues, conditions: conditions});
                                }}
                            >
                                <MenuItem value={"hide"}>Hide</MenuItem>
                                <MenuItem value={"show"}>Show</MenuItem>
                            </TextField>

                            <TextField
                                fullWidth
                                id="invoice"
                                label="Invoice"
                                value={variable.invoice}
                                name="invoice"
                                size="small"
                                select
                                onChange={(e) => {
                                    let conditions = {...logicValues.conditions};
                                    conditions.variables[variableIndex].invoice = e.target.value;
                                    setLogicvalues({...logicValues, conditions: conditions});
                                }}
                            >
                                <MenuItem value={"hide"}>Hide</MenuItem>
                                <MenuItem value={"show"}>Show</MenuItem>
                            </TextField>

                            <IconButton 
                                aria-label="delete" 
                                disabled={logicValues.conditions.variables.length === 1}
                                onClick={() => {
                                    let conditions = {...logicValues.conditions};
                                    conditions.variables.splice(variableIndex, 1);
                                    setLogicvalues({...logicValues, conditions: conditions});
                                }}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </div>
                    </div>
                ))}

                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        let conditions = {...logicValues.conditions};
                        conditions.variables.push({variable: "", bag: "show", cart: "show", checkout: "show", invoice: "show"});
                        setLogicvalues({...logicValues, conditions: conditions});
                    }}
                >
                    Add Product Option
                </Button>
            </div>
        </>
    )
}
